export class ExternalScanCount {
    cleared: number;
    failed: number;

    constructor() {
        this.cleared = this.failed = 0;
    }
}
